import Vue from 'vue'
import App from './App.vue'
import router from "@/router";
import store from '@/store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { resizeScale } from '@/utils/resetSize'
import './assets/iconfont.css'
import VueSmoothScroll from "vue2-smooth-scroll";
import "./assets/globalele.scss";
import 'echarts/extension/bmap/bmap';
import 'echarts/lib/component/grid'
import 'echarts-liquidfill';
Vue.use(ElementUI);
Vue.use(VueSmoothScroll)
Vue.config.productionTip = false



new Vue({
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
  router,
  store,
}).$mount('#app')

resizeScale()
